import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    width: 100%;
    padding: 30px 30px 40px;
  `,
    LayoutCardSection: styled.div `
    width: 100%;
    margin-bottom: 15px;
  `,
    CardSectionTitle: styled.div `
    margin-bottom: 10px;

    font-size: 18px;
    font-weight: 500;
  `,
    Card: styled.div `
    width: 100%;
    padding: 15px 20px;

    font-size: 16px;
    font-weight: 400;
    line-height: 23px;

    background: ${SEMANTIC_COLORS.PRIMARY_CARD_BACKGROUND};
    border-radius: 10px;
  `,
    CardBody: styled.div `
    width: 100%;
    margin: -7px 0;
  `,
    LayoutCardItems: styled.div `
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    row-gap: 5px;

    width: 100%;
    padding: 7px 0;

    border-bottom: ${(props) => props.isLast ? 'none' : `1px dashed ${SEMANTIC_COLORS.SECONDARY_BORDER}`};
  `,
    CardItem: styled.div `
    display: flex;
    align-items: center;
  `,
    CardNoData: styled.div `
    margin: 8px 0 15px;
  `,
    LayoutJustifyBetween: styled.div `
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    width: 100%;

    font-size: 16px;
    line-height: 23px;
  `,
    LayoutTotalFee: styled.div `
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    margin: 10px 0 0;

    & > span {
      display: flex;
      align-items: center;
      font-weight: 500;
    }
  `,
    LayoutNotes: styled.div `
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    row-gap: 5px;

    margin: 20px 0 7px;

    & > div {
      font-size: 16px;
      font-weight: 500;
      line-height: 23px;

      color: ${SEMANTIC_COLORS.SECONDARY_TEXT};
    }
  `,
    LayoutActionButtonSection: styled.div `
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;

    width: 100%;
    margin-top: 40px;
  `,
    LayoutForwardButton: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    & > div {
      margin-top: 5px;
      font-size: 16px;
      color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    }
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
